import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import media from '~/client/shared/media';

type Props = {
  isSubItem: boolean;
  children: React.ReactNode;
  onClick?: () => void;
};
const Item = styled.li<Props>`
  margin: 0;
  margin-bottom: ${rem(24)};
  padding: 0;
  color: ${({ theme }) => theme.color.bulma[100]};
  font-size: ${rem(14)};
  font-weight: ${({ theme }) => theme.fontWeight.normal};
  line-height: 1.5;
  list-style-position: inside;
  padding-left: ${({ isSubItem }) => (isSubItem ? rem(10) : 0)};
  list-style-type: ${({ isSubItem }) => (isSubItem ? 'disc' : 'none')};
  ${media.tabletSmall} {
    margin-bottom: ${rem(8)};
  }
`;

export default Item;
